/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wrapped_Strength_BestInputs */

const en_us2_wrapped_strength_best = /** @type {(inputs: Wrapped_Strength_BestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your best estimated max strength of the week.`)
};

const pt_br2_wrapped_strength_best = /** @type {(inputs: Wrapped_Strength_BestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua melhor força máxima estimada da semana.`)
};

const es_419_wrapped_strength_best = /** @type {(inputs: Wrapped_Strength_BestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu mejor fuerza máxima estimada de la semana.`)
};

const pt_pt2_wrapped_strength_best = /** @type {(inputs: Wrapped_Strength_BestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A tua melhor força máxima estimada da semana.`)
};

const fr_fr2_wrapped_strength_best = /** @type {(inputs: Wrapped_Strength_BestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta meilleure force max estimée de la semaine.`)
};

const de_de2_wrapped_strength_best = /** @type {(inputs: Wrapped_Strength_BestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine beste geschätzte Maximalkraft der Woche.`)
};

const it_it2_wrapped_strength_best = /** @type {(inputs: Wrapped_Strength_BestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tua migliore forza massima stimata della settimana.`)
};

/**
* | output |
* | --- |
* | "Your best estimated max strength of the week." |
*
* @param {Wrapped_Strength_BestInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_strength_best = /** @type {((inputs?: Wrapped_Strength_BestInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Strength_BestInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_strength_best(inputs)
	if (locale === "es-419") return es_419_wrapped_strength_best(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_strength_best(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_strength_best(inputs)
	if (locale === "de-DE") return de_de2_wrapped_strength_best(inputs)
	if (locale === "it-IT") return it_it2_wrapped_strength_best(inputs)
	return en_us2_wrapped_strength_best(inputs)
});
export { wrapped_strength_best as "wrapped.strength_best" }